var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "page-container container" }, [
    _c("div", { staticClass: "page-content-wrapper" }, [
      _c("div", { staticClass: "copyright-text" }, [
        _c("h2", [
          _vm._v("Die Internetseiten des CashPools werden betrieben durch die")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n\t\t\t\tYellowMap AG"),
          _c("br"),
          _vm._v("\n\t\t\t\tCAS-Weg 1-5 "),
          _c("br"),
          _vm._v("\n\t\t\t\tD-76131 Karlsruhe "),
          _c("br"),
          _vm._v("\n\t\t\t\tTelefon: +49 (0)721 9638 600 "),
          _c("br"),
          _vm._v("\n\t\t\t\tTelefax: +49 (0)721 9638 3600 "),
          _c("br"),
          _vm._v("\n\t\t\t\tInternet:\n\t\t\t\t"),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.navigateTo("https://www.yellowmap.com")
                }
              }
            },
            [_vm._v("https://www.yellowmap.com")]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v("\n\t\t\t\tE-Mail: "),
          _c("a", { attrs: { href: "mailto:kontakt@yellowmap.de" } }, [
            _vm._v("kontakt@yellowmap.de")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v("\n\t\t\t\tVorstand: Martin Hubschneider (Vorsitzender)"),
          _c("br"),
          _vm._v("\n\t\t\t\tAufsichtsrat: Dr. Helmut Melcher (Vorsitzender)"),
          _c("br"),
          _vm._v(
            "\n\t\t\t\tSitz: Karlsruhe, Amtsgericht Mannheim, Handelsregister-Nr.: 108853 "
          ),
          _c("br"),
          _vm._v("\n\t\t\t\tUst-ID-Nr.: DE 205827769\n\t\t\t")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }